import React from "react";
import { Navigate } from "react-router-dom";
import useAuthStore from "stores/useAuthStore";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  return isAuthenticated ? children : <Navigate to="/signup" />;
};

export default PrivateRoute;
